<template>
    <div class="custom-container">
        <!-- 操作区域 -->
        <div class="filter-container">
            <el-button @click="exportInfo" type="primary" size="mini"><i class="el-icon-download"></i>&nbsp;导出</el-button>
            <el-button @click="printInfo" type="primary" size="mini"><i class="el-icon-printer"></i>&nbsp;打印</el-button>
        </div>

        <!-- 表格区域 -->
        <div class="reportInfo" :style="{height:reportInfoHeight+ 'px'}">
            <table class="reportInfoTable" cellpadding="0" cellspacing="0">
                <tr class="tableTitle">
                    <td class="textCenter" colspan="9">
                        {{ reportInfo.semesterName }}成绩登记表
                    </td>
                </tr>
                <tr>
                    <td colspan="4">开课学院：{{ reportInfo.deptName }}</td>
                    <td colspan="3">任课教师：{{ reportInfo.teaName }}</td>
                    <td colspan="2">考核方式：{{ reportInfo.examType }}</td>
                </tr>
                <tr>
                    <td colspan="4">课程名称：{{ reportInfo.courseName }}</td>
                    <td colspan="3">课程代码：{{ reportInfo.courseCode }}</td>
                    <td colspan="2">学分：{{ reportInfo.credit }}</td>
                </tr>
                <tr>
                    <td colspan="9">班级名称：{{ reportInfo.className }}</td>
                </tr>
                <tr>
                    <td class="tableBorder textCenter" style="width: 60px;">序号</td>
                    <td class="tableBorder textCenter" style="width: 150px;">学号</td>
                    <td class="tableBorder textCenter" style="width: 150px;">姓名</td>
                    <td class="tableBorder textCenter" style="width: 80px;">平时</td>
                    <td class="tableBorder textCenter" style="width: 80px;">期中</td>
                    <td class="tableBorder textCenter" style="width: 80px;">实践</td>
                    <td class="tableBorder textCenter" style="width: 80px;">期末</td>
                    <td class="tableBorder textCenter" style="width: 80px;">总评成绩</td>
                    <td class="tableBorder textCenter" style="width: 100px;">备注</td>
                </tr>
                <tr v-for="(score, index) in reportInfo.scoreInfo">
                    <td class="tableBorder textCenter">{{ index+1 }}</td>
                    <td class="tableBorder textCenter">{{ score.stuCode }}</td>
                    <td class="tableBorder textCenter">{{ score.stuName }}</td>
                    <td class="tableBorder textCenter">{{ score.usualScore }}</td>
                    <td class="tableBorder textCenter">{{ score.midScore }}</td>
                    <td class="tableBorder textCenter">{{ score.trainingScore }}</td>
                    <td class="tableBorder textCenter">{{ score.finalScore }}</td>
                    <td class="tableBorder textCenter">{{ score.totalScore }}</td>
                    <td class="tableBorder textCenter"></td>
                </tr>
                <tr>
                    <td class="tableBorder textCenter" colspan="9">
                        考试/考查成绩统计
                    </td>
                </tr>
                <tr>
                    <td class="tableBorder" colspan="3">90分以上（优秀）</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.firstLevelNum }}&nbsp;人</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.firstLevelRatio }}&nbsp;%</td>
                </tr>
                <tr>
                    <td class="tableBorder" colspan="3">80-89分（良好）</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.secondLevelNum }}&nbsp;人</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.secondLevelRatio }}&nbsp;%</td>
                </tr>
                <tr>
                    <td class="tableBorder" colspan="3">70-79分（中等）</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.thirdLevelNum }}&nbsp;人</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.thirdLevelRatio }}&nbsp;%</td>
                </tr>
                <tr>
                    <td class="tableBorder" colspan="3">60-69分（及格）</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.fourthLevelNum }}&nbsp;人</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.fourthLevelRatio }}&nbsp;%</td>
                </tr>
                <tr>
                    <td class="tableBorder" colspan="3">不及格（不及格）</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.fifthLevelNum }}&nbsp;人</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.fifthLevelRatio }}&nbsp;%</td>
                </tr>
                <!-- <tr>
                    <td class="tableBorder" colspan="3">其他</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.otherLevelNum }}&nbsp;人</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.otherLevelRatio }}&nbsp;%</td>
                </tr> -->
                <tr>
                    <td class="tableBorder" colspan="3">合计</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.examNum }}&nbsp;人</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.totalLevelRatio }}&nbsp;%</td>
                </tr>
                <tr>
                    <td class="tableBorder" colspan="3">其他</td>
                    <td class="tableBorder" colspan="3">{{ reportInfo.statisticsInfo.otherLevelNum }}&nbsp;人</td>
                    <td class="tableBorder" colspan="3"></td>
                </tr>
                <tr>
                    <td class="tableBorder" colspan="3">
                        缓考&nbsp;{{ reportInfo.statisticsInfo.delayNum }}&nbsp;人
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        缺考&nbsp;{{ reportInfo.statisticsInfo.absentNum }}&nbsp;人
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        作弊&nbsp;{{ reportInfo.statisticsInfo.cheatNum }}&nbsp;人
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        未登分&nbsp;{{ reportInfo.statisticsInfo.emptyNum }}&nbsp;人
                    </td>
                    <td class="tableBorder" colspan="3">
                        免修&nbsp;/&nbsp;免考&nbsp;{{ reportInfo.statisticsInfo.exemptNum }}&nbsp;人
                    </td>
                    <td class="tableBorder" colspan="3">
                        实考&nbsp;{{ reportInfo.statisticsInfo.examNum }}&nbsp;人
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        总人数&nbsp;{{ reportInfo.statisticsInfo.totalNum }}&nbsp;人
                    </td>
                </tr>
                <tr>
                    <td colspan="9">
                        平时：{{ reportInfo.usualRatio }}&nbsp;%；
                        期中：{{ reportInfo.midRatio }}&nbsp;%；
                        实践：{{ reportInfo.trainingRatio }}&nbsp;% ；
                        期末：{{ reportInfo.finalRatio }}&nbsp;%
                    </td>
                </tr>
                <tr>
                    <td colspan="3">教研室主任：__________________</td>
                    <td colspan="3">任课老师：__________________</td>
                    <td colspan="3">日期：_______年____月____日</td>
                </tr>
                <tr>
                    <td colspan="9">
                        说明：任课教师应于考试/查后三天内，将本表一式两份报至所在系部。
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import { globalConfig } from "static/config"
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        props: {
            relatedCode: {
                type: String,
                default () {
                    return null;
                },
            },
            reportInfoHeight: {
                type: Number,
                default () {
                    return 840;
                },
            },
        },
        data() {
            return {
                queryForm: {
                    relatedCode: null,
                },
                // reportInfoHeight: 500,
                reportInfo: {
                    semesterName: null,
                    deptName: null,
                    teaName: null,
                    examType: null,
                    courseCode: null,
                    courseName: null,
                    credit: null,
                    className: null,
                    scoreInfo: [],
                    statisticsInfo : {
                        firstLevelNum: null,
                        firstLevelRatio: null,
                        secondLevelNum: null,
                        secondLevelRatio: null,
                        thirdLevelNum: null,
                        thirdLevelRatio: null,
                        fourthLevelNum: null,
                        fourthLevelRatio: null,
                        fifthLevelNum: null,
                        fifthLevelRatio: null,
                        otherLevelNum: null,
                        otherLevelRatio: null,
                        totalLevelNum: null,
                        totalLevelRatio: null,
                        delayNum: null,
                        absentNum: null,
                        exemptNum: null,
                        examNum: null,
                        totalNum: null,
                    },
                    usualRatio: null,
                    midRatio: null,
                    trainingRatio: null,
                    finalRatio: null,
                },
                loadingMask: null,
            }
        },
        mounted() {
            if(this.relatedCode){
                this.queryForm.relatedCode = this.relatedCode;
            }else{
                this.queryForm.relatedCode = this.$route.query.relatedCode;
            }
            if(this.$route.query.height) this.reportInfoHeight = this.$route.query.height;
            // this.reportInfoHeight = this.$route.query.height;
            // this.queryForm.relatedCode = this.$route.query.relatedCode;
            this.queryInfo();
        },
        methods: {
            queryInfo() {
                this.showLoadingMask("成绩登记表加载中，请稍候...");
                this.$api.scoreManage.statistics.subjectScoreReport.query({
                    data: this.queryForm,
                }).then((res) => {
                    this.reportInfo = res.data.data;
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.closeLoadingMask();
                });
            },
            exportInfo(){
                this.showLoadingMask("成绩登记表导出中，请稍候...");

                this.$api.scoreManage.statistics.subjectScoreReport.export({
                    responseType: "blob",
                    data: this.reportInfo
                }).then((res) => {
                    const _this = this;
                    const resultData = res.data;

                    const fileReader = new FileReader();
                    fileReader.onload = function() {
                       if (resultData.type == 'application/json') {
                           const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
                           showNotify('错误', jsonData.msg, 'error', 3000);
                       } else {
                           const fileName = decodeURI(res.headers['content-disposition'].split('fileName=')[1]);
                           _this.downloadFile(resultData, fileName);
                       }
                    };
                    fileReader.readAsText(resultData);
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.closeLoadingMask();
                });
            },
            printInfo(){
                this.showLoadingMask("成绩登记表打印处理中，请稍候...");

                this.$api.scoreManage.statistics.subjectScoreReport.print({
                    data: this.reportInfo
                }).then((res) => {
                    if (res.data.data.state == "Success") {
                        let win = window.open(" ");
                        win.document.write(res.data.data.htmlStr);
                        win.document.close();
                        win.print();
                        win.close();
                    }else{
                        showNotify('错误', res.data.data.msg, 'error', 3000);
                    }
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.closeLoadingMask();
                });
            },
            downloadFile(data, fileName) {
                let blob = new Blob([data], {type: "application/ms-excel;charset=utf-8"});

                //浏览器兼容，Google和火狐支持a标签的download，IE不支持
                if (window.navigator && window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    let url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.setAttribute("href", url);
                    link.setAttribute("download", fileName);
                    link.click();
                    link.remove();
                    URL.revokeObjectURL(url);
                }
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            closeLoadingMask() {
                if(this.loadingMask) this.loadingMask.close();
            },
        },
    }
</script>
<style scoped>
    .custom-container {
        padding: 20px 0 20px 20px;
    }

    .reportInfo {
        overflow: auto;
    }

    .reportInfoTable {
        border-collapse: collapse;
    }

    .reportInfoTable tr {
        height: 30px;
    }

    .reportInfoTable td {
        padding-left: 10px;
        font-size: 14px;
    }

    .reportInfoTable .tableBorder {
        border: 1px solid #000000;
    }

    .reportInfoTable .tableTitle {
        height: 50px;
    }

    .reportInfoTable .tableTitle td {
        font-size: 18px;
        font-weight: bold;
    }

    .reportInfoTable .textCenter {
        padding: 0;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// subjectScoreReport.vue?feadbda2